module.exports = __webpack_public_path__ + "img/gmail.52188fed.png";